import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Clock, Users, Star, ArrowRight } from 'lucide-react';
import { packages, PACKAGE_CATEGORIES } from '../data/packages';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/Experiences.css';

const Experiences = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('Hiking');

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  const filterLabels = {
    Hiking: t('packages.filters.hiking'),
    Couple: t('packages.filters.couple'),
    Family: t('packages.filters.family'),
    Cultural: t('packages.filters.cultural')
  };

  const filteredExperiences = packages.filter((p) => p.category === selectedCategory);

  return (
    <div className="experiences-page">
      {/* Page Header */}
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="container">
          <div className={`page-hero-content ${isVisible ? 'animated fadeIn' : 'animated'}`}>
            <h1 className="display-large">{t('packages.hero')}</h1>
            <p className="body-large">{t('packages.heroSub')}</p>
          </div>
        </div>
      </section>

      {/* Category Filter — only 4 categories */}
      <section className="category-filter-section">
        <div className="container">
          <div className="category-filter">
            {PACKAGE_CATEGORIES.map((category) => (
              <button
                key={category}
                className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category)}
                data-testid={`packages-filter-${category.toLowerCase()}`}
              >
                {filterLabels[category]}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Experiences Listing */}
      <section className="experiences-listing">
        <div className="container">
          <div className="experiences-list">
            {filteredExperiences.map((experience, index) => (
              <div
                key={experience.id}
                className={`experience-item ${isVisible ? 'animated fadeIn' : 'animated'}`}
                style={{ transitionDelay: `${index * 50}ms` }}
                data-testid={`package-card-${experience.id}`}
              >
                <Link to={`/experiences/${experience.id}`} className="experience-item-image">
                  <img src={experience.image} alt={experience.title} />
                  <span className="category-badge">{filterLabels[experience.category]}</span>
                </Link>
                <div className="experience-item-content">
                  <h3 className="heading-2">
                    <Link to={`/experiences/${experience.id}`} className="package-title-link">
                      {experience.title}
                    </Link>
                  </h3>
                  <p className="body-medium">{experience.shortDescription}</p>

                  <div className="experience-details">
                    <div className="detail-item"><Clock size={18} /><span>{experience.duration}</span></div>
                    <div className="detail-item"><Users size={18} /><span>{experience.groupSize}</span></div>
                    <div className="detail-item difficulty"><Star size={18} /><span>{experience.difficulty}</span></div>
                  </div>

                  <div className="experience-highlights">
                    <h4>{t('packages.highlights')}:</h4>
                    <ul>
                      {experience.highlights.slice(0, 4).map((h, i) => <li key={i}>{h}</li>)}
                    </ul>
                  </div>

                  <div className="experience-footer">
                    <div className="price-tag">
                      <span className="price-label">{t('packages.from')}</span>
                      <span className="price">€{experience.price}</span>
                      <span className="price-per">{t('packages.perPerson')}</span>
                    </div>
                    <Link to={`/experiences/${experience.id}`} className="btn-primary" data-testid={`package-readmore-${experience.id}`}>
                      {t('packages.readMore')} <ArrowRight size={18} />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Experiences;
